<template>
  <SubTitle :TitleName="'スクリーンショット'" />
  <v-row class="w-75 mx-auto justify-center flex-wrap ma-5">
    <v-col v-for="n in 6" :key="n" class="d-flex child-flex" cols="6" md="4">
      <v-img
        @click="openDialog(n)"
        :lazy-src="`http://d-mebius.com/apathyboy/img/s${String(n - 1).padStart(
          2,
          '0'
        )}.png`"
        :src="`http://d-mebius.com/apathyboy/img/s${String(n - 1).padStart(
          2,
          '0'
        )}.png`"
        aspect-ratio="16/9"
        class="bg-grey-lighten-2 elevation-4"
        cover
        :alt="`ScreenShot ${n}`"
      >
        <template v-slot:placeholder>
          <v-row align="center" class="fill-height ma-0" justify="center">
            <v-progress-circular
              color="grey-lighten-5"
              indeterminate
            ></v-progress-circular>
          </v-row> </template
      ></v-img>
    </v-col>
  </v-row>
  <v-dialog v-model="dialog" max-width="1280">
    <v-card>
      <v-img
        :src="selectedImageURL"
        aspect-ratio="16/9"
        class="bg-grey-lighten-2"
        cover
        :alt="`ScreenShot ${selectedImage}`"
      >
      </v-img>
    </v-card>
  </v-dialog>
</template>

<script>
  import SubTitle from "./SubTitle.vue";
  export default {
    components: {
      SubTitle,
    },
    data() {
      return {
        dialog: false,
        selectedImage: 1, // 初期選択画像番号
      };
    },
    computed: {
      selectedImageURL() {
        return `http://d-mebius.com/apathyboy/img/s${String(
          this.selectedImage - 1
        ).padStart(2, "0")}.png`;
      },
    },
    methods: {
      openDialog(n) {
        this.selectedImage = n; // ダイアログ内で表示する画像の番号を更新
        this.dialog = true; // ダイアログを開く
      },
    },
  };
</script>
<style scoped>
  .btn {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
</style>
